import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/switching/professional/mission-critical.png";
import type { Product } from "../../types";
import { switchingProfessional } from "../product-list-groups/switchingProfessional";
import { etherlighting, proAvSupport } from "../properties";
import { downlinkSpeed } from "../properties/downlinkSpeed";
import { mounting } from "../properties/mounting";
import { outdoorReady } from "../properties/outdoorReady";
import { poeAvailability } from "../properties/poeAvailability";
import { poeOutput } from "../properties/poeOutput";
import { portCount } from "../properties/portCount";
import { powerMethod } from "../properties/powerMethod";
import { switchTechnology } from "../properties/switchTechnology";
import { uplinkSpeed } from "../properties/uplinkSpeed";

export const missionCritical: Product = {
  id: "missionCritical",
  productTitle: "Mission Critical",
  techspecsPath: [SiteId.TechSpecs, "/unifi/switching/usw-mission-critical"],
  storePathParts: {
    productSlug: "usw-mission-critical",
    category: "switching-enterprise",
  },
  sku: "USW-Mission-Critical-EU",
  description: "missionCritical.description",
  descriptionMaxWidth: 180,
  image: { src: image, width: 200, height: 140 },
  productListGroup: switchingProfessional,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '442 x 480 x 44 mm\n(17.4 x 18.9 x 1.7")',
      },
    },
    {
      propertyId: switchTechnology.id,
      value: {
        type: "translation",
        value: "commons.switchingTechnology.layer2",
      },
    },
    {
      propertyId: portCount.id,
      value: { type: "string", value: "8" },
    },
    {
      propertyId: downlinkSpeed.id,
      value: { type: "string", value: "1 Gbps" },
    },
    {
      propertyId: uplinkSpeed.id,
      value: { type: "string", value: "1 Gbps" },
    },
    {
      propertyId: poeOutput.id,
      value: {
        type: "translation",
        value: "commons.poeOutput.upToPoe++",
      },
    },
    {
      propertyId: poeAvailability.id,
      value: { type: "string", value: "120 W" },
    },
    {
      propertyId: proAvSupport.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "generalRedundancy",
      value: {
        type: "translation",
        value: "missionCritical.powerRedundancy",
      },
    },
    {
      propertyId: powerMethod.id,
      value: {
        type: "translation",
        value: "commons.powerMethod.acPower",
      },
    },
    {
      propertyId: etherlighting.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: mounting.id,
      value: {
        type: "translation",
        value: "commons.mounting.rack",
      },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "boolean", value: false },
    },
  ],
};
